import { Back, TweenLite } from 'gsap';
import { isIOS } from 'mobile-device-detect';
import { GameAudio } from '../Config/Audio';
import { BOOSTER_LIST } from '../Config/Items';
import { getGameSize, IGameSizeInfo, ILevelConfig } from '../Config/Levels';
import Core, { GameOrientation } from '../Core/Core';
import { gameConfig } from '../index';
import { HudActions, HudEmitter } from '../Managers/Hud/HudEmitter';
import { Popup } from '../Managers/Popups';
import { PurchaseStatus } from '../SDK/ISDKpayments';
import { Platform } from '../SDK/SDK';
import { IFBFriend } from '../SDK/SDKfb';
import { ShareableMoments } from '../SDK/SDKmessages';
import SoundManager from '../Sound/SoundManager';
import { Actions, GameContainerAction } from '../State/Actions/Actions';
import { BoosterId } from '../State/reducers/boosters';
import { IDailyMission } from '../State/reducers/missions';
import { ICollectablesData } from '../State/reducers/player';
import { IRewardItem } from '../State/reducers/score';
import { Views } from '../State/reducers/view';
import { IConfirmedInvite, IInvite } from '../State/socialHelpers';
import { Collection } from '../Tiles/TileSet';
import { Animation } from '../UI/Animations/Animation';
import { AddCoinsAnimationInGame, AddCurrencyAnimation } from '../UI/Animations/UIAnimations';
import { BottomUi } from '../UI/Game/BottomUI/BottomUi';
import { BoosterParachute } from '../UI/Game/Helpers/BoosterParachute';
import { TopUi } from '../UI/Game/TopUI/TopUi';
import { BottomMapUi } from '../UI/Map/BottomMapUi';
import { PrizeWheelPopup } from '../UI/Map/PrizeWheelPopup';
import TopMapUi from '../UI/Map/TopMapUi';
import { AdErrorPopup } from '../UI/PopUps/AdErrorPopup';
import { BotRewardPopup } from '../UI/PopUps/BotRewardPopup';
import { CrossPromoPopup } from '../UI/PopUps/CrossPromo/CrossPromoPopup';
import { CurrencyNeededPopup } from '../UI/PopUps/CurrencyNeededPopup';
import { DoubleCheckPopup } from '../UI/PopUps/DoubleCheckPopup';
import { InfoPopup } from '../UI/PopUps/InfoPopup';
import { JournalPopup } from '../UI/PopUps/Journal/JournalPopup';
import { MapGatePopup } from '../UI/PopUps/MapGatePopup';
import { LevelLeaderboard } from '../UI/PopUps/Prelevel/LevelLeaderboard';
import { PreLevelPopup } from '../UI/PopUps/Prelevel/PreLevelPopup';
import { RewardPopup } from '../UI/PopUps/RewardPopup';
import { PurchaseStatusPopup } from '../UI/PopUps/Shop/PurchaseStatusPopup';
import { ShopPopup } from '../UI/PopUps/Shop/ShopPopup';
import { FriendJoinedPopup } from '../UI/PopUps/Social/FriendJoinedPopup';
import { GiftReceivedPopup } from '../UI/PopUps/Social/GiftReceivedPopup';
import { LoadingSocialInteraction } from '../UI/PopUps/Social/LoadingSocialInteraction';
import { INews } from '../UI/PopUps/Social/News';
import { JackpotShareableOverlay } from '../UI/PopUps/Social/ShareableMoments/JackpotShareableOverlay';
import { MapCompleteShareableOverlay } from '../UI/PopUps/Social/ShareableMoments/MapCompleteShareableOverlay';
import { ShareablePopup } from '../UI/PopUps/Social/ShareableMoments/ShareablePopup';
import { SocialHubPopup } from '../UI/PopUps/Social/SocialHubPopup';
import { CollapsibleGroup } from '../UI/Shared/Buttons/CollapsibleGroup';
import CornerButton from '../UI/Shared/Buttons/CornerButton';
import { IconButton } from '../UI/Shared/Buttons/IconButton';
import { ButtonColors } from '../UI/Shared/Buttons/NineSliceButton';
import { PrizeWheelButton } from '../UI/Shared/Buttons/PrizeWheelButton';
import { UIButton } from '../UI/Shared/Buttons/UIButton';
import { EmbeddedSprite } from '../UI/Shared/EmbeddedSprite';
import { ScreenBlur } from '../UI/Shared/ScreenBlur';
import { getCollectionInProgress, getCollectionProgress } from '../Utils/CollectableUtils';
import { createOutlineText } from '../Utils/Utils';
import Product = FBInstant.Product;
import Point = PIXI.Point;
import { deviceIsPhone } from '../Utils/Platform';
import { FocusManager } from '../Managers/FocusManager';

interface IPauseGroup {
    group: CollapsibleGroup;
    musicButton: IconButton;
    soundButton: IconButton;
    infoButton: IconButton;
    quitButton: IconButton;
}

export default class HudView extends PIXI.Container {
    public topUi: TopUi;
    public bottomUi: BottomUi;
    public mapUi: TopMapUi;
    public mapBottomUi: BottomMapUi;

    public pauseGroup: IPauseGroup;
    public giveUpBtn: UIButton;
    public socialPopup: SocialHubPopup;
    public journalPopup: JournalPopup;
    public shopPopup: ShopPopup;
    public friendJoinedPopup: FriendJoinedPopup;
    public giftReceivedPopup: GiftReceivedPopup;
    public currencyPopup: CurrencyNeededPopup;
    public prelevelContainer: PIXI.Container;
    public prelevelPopup: PreLevelPopup;
    public levelLeaderboard: LevelLeaderboard;
    public screenBlur: ScreenBlur;
    public prizeWheelPopup: PrizeWheelPopup;
    public prizeWheelBtn: PrizeWheelButton;
    private currencyNeededPopup: CurrencyNeededPopup;
    private doubleCheckPopup: DoubleCheckPopup;
    private botRewardPopup: BotRewardPopup;
    private rewardPopup: RewardPopup;
    private purchaseStatusPopup: PurchaseStatusPopup;
    private loadSocial: LoadingSocialInteraction;
    private loadAdText: PIXI.Text;
    private adError: AdErrorPopup;
    private shareablePopup: ShareablePopup;
    private infoPopup: InfoPopup;
    private crossPromoPopup: CrossPromoPopup;
    private lockList: string[] = [];
    private rewardAnims: AddCurrencyAnimation[] = [];
    private cornerButtons: CornerButton[] = [];
    private blurs: number[] = [];

    constructor() {
        super();
    }

    public update() {
        //
    }

    public resize(sizeInfo: IGameSizeInfo) {
        const isPortrait = Core.orientation === GameOrientation.PORTRAIT;
        const currentPortrait = window.innerWidth > window.innerHeight ? false : true;
        const isNetworkLand =
            sgPlatform === Platform.Network && window.innerHeight < window.innerWidth;

        if (deviceIsPhone()) {
            if (isPortrait !== currentPortrait) {
                document.getElementById(
                    !isPortrait ? 'orientation-landscape' : 'orientation-portrait'
                ).style.display = 'block';
                FocusManager.instance.unFocus();
            } else {
                document.getElementById(
                    !isPortrait ? 'orientation-landscape' : 'orientation-portrait'
                ).style.display = 'none';
                FocusManager.instance.focus();
            }
        }

        if (this.topUi) {
            if (isPortrait) {
                this.topUi.x = (sizeInfo.gameWidth - this.topUi.width) / 2;
            } else {
                this.topUi.x = sizeInfo.xOffset * 0.5 - this.topUi.bg.width * 0.5;
                this.topUi.y = sizeInfo.gameHeight * 0.5 - this.topUi.bg.height * 0.5;
            }
        }

        if (this.bottomUi) {
            this.bottomUi.resize(sizeInfo);
        }

        if (this.mapUi) {
            isNetworkLand && deviceIsPhone() ? this.mapUi.scale.set(2) : this.mapUi.scale.set(1);
            this.mapUi.x = (sizeInfo.gameWidth - this.mapUi.width) / 2;
        }

        if (this.mapBottomUi) {
            this.mapBottomUi.resize(sizeInfo);
            isNetworkLand && deviceIsPhone()
                ? this.mapBottomUi.scale.set(1.5)
                : this.mapBottomUi.scale.set(1);
        }

        if (this.pauseGroup) {
            const { group } = this.pauseGroup;
            isNetworkLand && deviceIsPhone() ? group.scale.set(2) : group.scale.set(1);
            if (isPortrait) {
                group.x = sizeInfo.gameWidth - group.width * 0.6;
                group.y = sizeInfo.gameHeight - group.height * 0.6;
            } else {
                group.x = group.width * 0.6;
                group.y = sizeInfo.gameHeight - group.height * 0.6;
            }
        }
        if (this.socialPopup) {
            this.socialPopup.resize(sizeInfo);
        }
        if (this.journalPopup) {
            this.journalPopup.resize(sizeInfo);
        }
        if (this.friendJoinedPopup) {
            this.friendJoinedPopup.x = gameConfig.game_width * 0.05 + sizeInfo.xOffset;
            this.friendJoinedPopup.resize(sizeInfo);
        }
        if (this.giftReceivedPopup) {
            this.giftReceivedPopup.x = gameConfig.game_width * 0.05 + sizeInfo.xOffset;
            this.giftReceivedPopup.resize(sizeInfo);
        }
        if (this.prizeWheelPopup) {
            this.prizeWheelPopup.resize(sizeInfo);
        }
        if (this.prizeWheelBtn) {
            if (isPortrait) {
                this.prizeWheelBtn.x = gameConfig.game_width * 0.85 + sizeInfo.xOffset * 2;
            } else {
                this.prizeWheelBtn.x = getGameSize().gameWidth - getGameSize().gameWidth * 0.085;
                this.prizeWheelBtn.y = getGameSize().gameHeight * 0.125;
            }
        }
        if (this.currencyNeededPopup) {
            this.currencyNeededPopup.x = gameConfig.game_width * 0.05 + sizeInfo.xOffset;
        }
        if (this.doubleCheckPopup) {
            this.doubleCheckPopup.x = gameConfig.game_width * 0.05 + sizeInfo.xOffset;
        }
        /*        if (this.mapGatePopup) {
        this.mapGatePopup.x = gameConfig.game_width * 0.05 + sizeInfo.xOffset;
    }*/
        if (this.rewardPopup) {
            this.rewardPopup.x = gameConfig.game_width * 0.05 + sizeInfo.xOffset;
        }

        if (this.prelevelPopup) {
            this.prelevelPopup.x = gameConfig.game_width * 0.05 + sizeInfo.xOffset;
        }
        if (this.levelLeaderboard) {
            this.levelLeaderboard.y = sizeInfo.gameHeight;
        }
        if (this.loadSocial) {
            this.loadSocial.x = sizeInfo.gameWidth / 2;
            this.loadSocial.resize(sizeInfo);
        }
        if (this.loadAdText) {
            this.loadAdText.x = sizeInfo.gameWidth / 2;
        }
        if (this.screenBlur) {
            this.screenBlur.resize(sizeInfo);
        }
        if (this.adError) {
            this.adError.x = gameConfig.game_width * 0.05 + sizeInfo.xOffset;
        }
    }

    public showXPromoPopup(banner: EmbeddedSprite, gameId: number, gameName: string) {
        const gameSize = getGameSize();
        this.blurBackground();
        const crossPromoPopup = new CrossPromoPopup(
            gameConfig.game_width * 0.9,
            gameSize.gameHeight * 0.7,
            banner,
            gameId,
            gameName
        );
        this.crossPromoPopup = crossPromoPopup;
        this.addChild(crossPromoPopup);
        crossPromoPopup.x = gameConfig.game_width * 0.05 + gameSize.xOffset;
        crossPromoPopup.y = gameSize.gameHeight + 500;
        crossPromoPopup.tweenIn();
    }

    public removeXPromoPopup() {
        this.removeBlur();
        this.crossPromoPopup.tweenOut();
        this.crossPromoPopup = null;
    }

    public showInfoPopup(playerId: string) {
        const gameSize = getGameSize();
        this.blurBackground();
        const infoPopup = new InfoPopup(
            gameConfig.game_width * 0.9,
            gameSize.gameHeight * 0.7,
            playerId
        );
        this.infoPopup = infoPopup;
        this.addChild(infoPopup);
        infoPopup.x = gameConfig.game_width * 0.05 + gameSize.xOffset;
        infoPopup.y = gameSize.gameHeight + 500;
        infoPopup.tweenIn();
    }

    public removeInfoPopup() {
        this.removeBlur();
        this.infoPopup.tweenOut();
        this.infoPopup = null;
    }

    public showModal() {
        const check = new DoubleCheckPopup(Core.local.getText('quitlevel'));
        this.doubleCheckPopup = check;
        this.blurBackground();
        this.addChild(check);
        check.tweenIn();
    }

    public removeModal() {
        if (this.doubleCheckPopup) {
            this.removeBlur();
            this.doubleCheckPopup.tweenOut();
            this.doubleCheckPopup = null;
        }
    }

    public addAdError() {
        const gameSize = getGameSize();
        this.blurBackground();
        const adErrorPopup = new AdErrorPopup(
            gameConfig.game_width * 0.9,
            gameConfig.game_height * 0.6
        );
        this.adError = adErrorPopup;
        this.addChild(adErrorPopup);
        adErrorPopup.x = gameConfig.game_width * 0.05 + gameSize.xOffset;
        adErrorPopup.y = gameSize.gameHeight + 500;
        adErrorPopup.tweenIn();
    }

    public removeAdError() {
        this.removeBlur();
        this.adError.tweenOut();
        this.adError = null;
    }

    public addShareablePopup(type: ShareableMoments, payload: string, flash: boolean) {
        let titleKey = 'amazing';
        let overlay = null;

        if (type === ShareableMoments.NEW_MAP) {
            titleKey = 'MapCompleted';
            overlay = new MapCompleteShareableOverlay(payload);
        } else if (type === ShareableMoments.JACKPOT) {
            overlay = new JackpotShareableOverlay();
        } else {
            return;
        }

        this.shareablePopup = new ShareablePopup(titleKey, overlay, type, flash);
        this.addChild(this.shareablePopup);
        this.shareablePopup.tweenIn();
    }

    public async removeShareablePopup() {
        if (!this.shareablePopup) {
            return;
        }
        const shareablePopup = this.shareablePopup;
        this.shareablePopup = null;
        await shareablePopup.tweenOut();
        this.removeChild(shareablePopup);
        shareablePopup.destroy();
    }

    public addPreLevel(
        boosters: string[],
        config: ILevelConfig,
        helperFriend: IFBFriend,
        collection: Collection
    ) {
        const gameSize = getGameSize();
        this.blurBackground();
        // this.addChild(bg);
        const prelevelContainer = new PIXI.Container();
        const prelevel = (this.prelevelPopup = new PreLevelPopup(
            gameConfig.game_width * 0.9,
            gameConfig.game_height * 0.7,
            config,
            boosters,
            (id: string, isSelected: boolean) => {
                this.handleBoosterSelect(id, isSelected);
            },
            helperFriend,
            collection
        ));
        this.prelevelContainer = prelevelContainer;
        prelevel.x = gameConfig.game_width * 0.05 + gameSize.xOffset;
        prelevel.y = gameSize.gameHeight + 500;
        const { gameWidth, gameHeight } = gameSize;

        const levelLeaderboard = (this.levelLeaderboard = new LevelLeaderboard(gameWidth));
        levelLeaderboard.y = gameHeight;
        levelLeaderboard.visible = sgPlatform === Platform.Network ? false : true;
        prelevelContainer.addChild(prelevel);
        prelevelContainer.addChild(levelLeaderboard);
        this.addChild(prelevelContainer);
        prelevel.tweenIn();
        return { prelevel, levelLeaderboard };
    }

    public removePrelevel(args: string, callback: (args: string) => void) {
        SoundManager.playSound(GameAudio.WHOOSH_OUT);
        if (this.screenBlur) {
            const { screenBlur } = this;
            this.screenBlur = null;
            TweenLite.to(screenBlur, 0.5, {
                alpha: 0,
                onComplete: () => {
                    screenBlur.destroyBlur();
                },
            });
        }
        if (this.prelevelContainer) {
            const { prelevelContainer } = this;
            this.prelevelContainer = null;
            TweenLite.to(prelevelContainer, 0.3, {
                onComplete: () => {
                    prelevelContainer.destroy();
                    callback(args);
                },
                y: getGameSize().gameHeight + 500,
            });
        }
    }

    public addCurrencyNeeded(
        itemNeeded: string,
        currentAmt: number,
        outOfResource: boolean = true
    ) {
        const gameSize = getGameSize();
        this.blurBackground();

        const currencyNeeded = new CurrencyNeededPopup(
            itemNeeded,
            currentAmt,
            itemNeeded,
            outOfResource
        );
        currencyNeeded.x = gameConfig.game_width * 0.05 + gameSize.xOffset;
        currencyNeeded.y = gameSize.gameHeight + 500;
        this.currencyPopup = currencyNeeded;
        // this.screenBlur = bg;

        this.addChild(currencyNeeded);

        SoundManager.playSound(GameAudio.WHOOSH_IN);

        TweenLite.to(currencyNeeded, 0.7, {
            ease: Back.easeOut.config(2),
            y: gameSize.yOffset + gameConfig.game_height * 0.2,
        });
    }

    public removeCurrencyNeeded(confirm: boolean, action?: string) {
        const oldPopup = this.currencyPopup;
        const oldBlur = this.screenBlur;
        this.currencyPopup = null;
        this.screenBlur = null;

        SoundManager.playSound(GameAudio.WHOOSH_OUT);

        TweenLite.to(oldPopup, 0.7, {
            ease: Back.easeIn.config(2),
            onComplete: () => {
                if (oldPopup) {
                    oldPopup.destroy();
                }
                HudEmitter.instance.emit(
                    HudActions.CLOSE_POPUP,
                    Popup.CURRENCY,
                    0,
                    confirm,
                    action
                );
                if (oldBlur) {
                    oldBlur.fade(0, 100);
                }
            },
            y: getGameSize().gameHeight + 500,
        });
    }

    public handleBoosterSelect(id: string, isSelected: boolean) {
        this.emit(GameContainerAction.GAME_PRELEVEL_BOOSTER, [id, isSelected]);
    }

    public createMapUi() {
        const m = new TopMapUi();
        if (Core.orientation === GameOrientation.PORTRAIT) {
            m.x = (gameConfig.game_width - m.width) / 2;
        } else {
            m.x = getGameSize().gameWidth * 0.05;
        }

        this.addChild(m);
        this.mapUi = m;
        return m;
    }

    public createMapBottomUi() {
        const b = new BottomMapUi();
        b.anchor.set(0.5);
        this.mapBottomUi = b;
        this.addChild(b);
        return b;
    }

    public createBottomUi(currentBoosters: string[]) {
        const b = new BottomUi(currentBoosters);
        this.addChild(b);
        this.bottomUi = b;
        b.alpha = 0;

        this.lockList.forEach(l => this.bottomUi.boosters.lockBooster(l, true));
        TweenLite.to(b, 1, { alpha: 1 });

        return b;
    }

    public createTopUi(winTime: number): TopUi {
        const topUI = new TopUi(winTime);
        if (Core.orientation === GameOrientation.PORTRAIT) {
            topUI.x = (getGameSize().gameWidth - topUI.width) / 2;
            topUI.y = -15;
        } else {
            topUI.x = getGameSize().xOffset * 0.5 - topUI.bg.width * 0.5;
            topUI.y = getGameSize().gameHeight * 0.5 - topUI.bg.height * 0.5;
        }

        this.addChild(topUI);
        topUI.alpha = 0;

        TweenLite.to(topUI, 1, { alpha: 1 });
        this.topUi = topUI;
        return topUI;
    }

    public deleteUi(ui: TopUi | BottomUi | TopMapUi | BottomMapUi) {
        if (ui === this.mapBottomUi) {
            this.mapBottomUi.cleanUp();
        }

        ui.destroy();

        if (ui === this.topUi) {
            this.topUi.cleanUp();
            this.topUi = null;
        }
        if (ui === this.bottomUi) {
            this.bottomUi = null;
            this.hideGiveUpBtn(false);
        }
        if (ui === this.mapUi) {
            this.mapUi = null;
        }

        if (ui === this.mapBottomUi) {
            this.mapBottomUi = null;
        }

        if (this.rewardAnims) {
            this.rewardAnims.forEach(x => {
                x.cleanUp();
            });
            this.rewardAnims = [];
        }
    }

    public createFriendJoinedPopup(player: IConfirmedInvite) {
        // console.log('url: ', player.avatar, 'name: ', player.name);
        if (!this.friendJoinedPopup) {
            this.friendJoinedPopup = new FriendJoinedPopup(
                gameConfig.game_width * 0.9,
                gameConfig.game_height * 0.7,
                player.avatar,
                player.name
            );
            this.addChild(this.friendJoinedPopup);
            try {
                this.friendJoinedPopup.tweenIn();
            } catch (error) {}

            Core.store.dispatch(Actions.removeInvitation(player.userId));
        }
    }

    public async removeFriendJoinedPopup() {
        await this.friendJoinedPopup.tweenOut();
        this.removeChild(this.friendJoinedPopup);
        this.friendJoinedPopup.destroy();
        this.friendJoinedPopup = null;
    }

    public createGiftReceivedPopup(player: any) {
        if (!this.giftReceivedPopup || this.giftReceivedPopup === null) {
            this.giftReceivedPopup = new GiftReceivedPopup(
                gameConfig.game_width * 0.9,
                gameConfig.game_height * 0.7,
                player.avatar,
                player.name
            );
            this.giftReceivedPopup.tweenIn().catch(err => {
                console.log(['error gift received popup tweenin', err]);
            });
            this.addChild(this.giftReceivedPopup);
        }
    }

    public async removeGiftReceivedPopup() {
        await this.giftReceivedPopup.tweenOut();
        this.removeChild(this.giftReceivedPopup);
        this.giftReceivedPopup.destroy();
        this.giftReceivedPopup = null;
    }

    public createLoadSocial() {
        if (this.loadSocial) {
            return;
        }
        this.loadSocial = new LoadingSocialInteraction();
        this.addChild(this.loadSocial);
        this.loadSocial.tweenIn().catch(err => {
            console.log(['error load social tween', err]);
        });
    }

    public async removeLoadSocial() {
        if (this.loadSocial) {
            const { loadSocial } = this;
            // this.loadSocial.destroy();
            this.loadSocial = null;
            loadSocial.tweenOut();
        }
    }

    public createLoadAdText() {
        if (this.loadAdText) {
            return;
        }

        this.blurBackground();

        const loadT = createOutlineText(
            Core.local.getText('loadvideo'),
            new PIXI.Rectangle(
                getGameSize().gameWidth / 2,
                getGameSize().gameHeight / 2,
                getGameSize().gameWidth * 0.7,
                getGameSize().gameHeight * 0.4
            ),
            'Baloo',
            60,
            60
        );
        loadT.alpha = 0;
        TweenLite.to([loadT], 0.2, { alpha: 1 });
        this.loadAdText = loadT;
        this.addChild(loadT);
    }

    public deleteLoadAdText() {
        if (!this.loadAdText) {
            return;
        }
        const loadAdText = this.loadAdText;
        this.loadAdText = null;
        TweenLite.to(loadAdText, 0.2, {
            alpha: 0,
            onComplete: () => {
                loadAdText.destroy();
            },
        });
        this.removeBlur();
    }

    public deletePause() {
        if (!this.pauseGroup) {
            return;
        }
        this.pauseGroup.group.destroy();
        this.pauseGroup = null;
    }

    public showPauseBtn() {
        if (this.pauseGroup) {
            this.pauseGroup.group.interactive = true;
            this.pauseGroup.group.visible = true;
            return;
        }
        this.createPauseGroup();
    }

    public updatePauseGroup({
        music,
        sfx,
        view,
    }: {
        music?: boolean;
        sfx?: boolean;
        view?: string;
    }) {
        if (!this.pauseGroup) {
            return;
        }
        const { group, musicButton, soundButton, infoButton, quitButton } = this.pauseGroup;
        if (music !== null && music !== undefined) {
            musicButton.enabled = music;
        }
        if (sfx !== null && sfx !== undefined) {
            soundButton.enabled = sfx;
        }
        if (!view) {
            return;
        }
        this.pauseGroup.group.setCollapsed(true).then(() => (pauseBtn.icon.rotation = 0));
        const inGame = view === Views.GAME;
        const icon = inGame ? 'commonui/button-icon-pause' : 'commonui/button-icon-settings';
        const pauseBtn = group.collapseButton as IconButton;
        const texture = PIXI.utils.TextureCache[icon];
        pauseBtn.icon.texture = texture;
        pauseBtn.animate = !inGame;
        if (inGame) {
            group.removeItem(infoButton);
            group.addItem(quitButton);
        } else {
            group.addItem(infoButton);
            group.removeItem(quitButton);
        }
    }

    public hidePauseBtn() {
        if (!this.pauseGroup) {
            return;
        }
        const pauseBtn = this.pauseGroup.group.collapseButton as IconButton;
        this.pauseGroup.group.setCollapsed(true).then(() => (pauseBtn.icon.rotation = 0));
        this.pauseGroup.group.visible = false;
    }

    public showGiveUpBtn() {
        if (this.giveUpBtn) {
            return this.giveUpBtn;
        }
        const button = (this.giveUpBtn = new IconButton({
            color: ButtonColors.RED,
            icon: 'commonui/button-icon-quit',
        }));
        this.addChild(button);
        button.position = this.pauseGroup.group.position;
        button.scale = button.originalScale = new Point(
            this.pauseGroup.group.scale.x,
            this.pauseGroup.group.scale.y
        );
        this.hidePauseBtn();
        return button;
    }

    public hideGiveUpBtn(showPause: boolean = true) {
        if (!this.giveUpBtn) {
            return;
        }
        this.giveUpBtn.destroy();
        this.giveUpBtn = null;
        if (showPause) {
            this.showPauseBtn();
        }
    }

    public async createSocialPopup(
        pending: IInvite[],
        curGiftCounter: number,
        weekly: any[],
        leaderboard: any[],
        news: INews[]
    ) {
        this.socialPopup = new SocialHubPopup(this, pending, curGiftCounter);
        this.addChild(this.socialPopup);
        await this.socialPopup
            .createOnLeaderboardData(weekly, leaderboard, news, !isIOS)
            .catch(err => {
                console.log(['error with social createOnLeaderboard', err]);
            });
        this.socialPopup.tweenIn().catch(err => {
            console.log(['error social tweenin create', err]);
        });
    }

    public async deleteSocialPopup() {
        await this.socialPopup.tweenOut().catch(err => {
            console.log(['error delete social tween', err]);
        });
        this.socialPopup = null;
    }

    public async createShopPopup(catalog: Product[]) {
        this.shopPopup = new ShopPopup(this, catalog);
        this.addChild(this.shopPopup);
        await this.shopPopup.tweenIn();
    }

    public showFreeGift() {
        this.shopPopup.showFreeGift();
    }

    public updateShopCatalog(catalog: Product[]) {
        this.shopPopup.setCatalog(catalog);
    }

    public async deleteShopPopup() {
        await this.shopPopup.tweenOut();
        this.shopPopup = null;
    }

    public createJournalPopup(
        missions: IDailyMission[],
        curMissionCount: number,
        curMilestone: number,
        collectablesProgress: ICollectablesData,
        selectedCollectable: Collection
    ) {
        if (!this.journalPopup) {
            this.journalPopup = new JournalPopup(
                this,
                curMissionCount,
                missions,
                curMilestone,
                collectablesProgress,
                selectedCollectable
            );
            this.addChild(this.journalPopup);
            this.journalPopup.tweenIn().catch(err => {
                console.log(['error journal tweenin', err]);
            });
        }
    }

    public async deleteJournalPopup() {
        if (!this.journalPopup) {
            return;
        }
        await this.journalPopup.tweenOut().catch(err => {
            console.log(['error journal tweenout', err]);
        });
        this.journalPopup = null;
    }

    public createMapGatePopup(mapId: string, mapList: string[]) {
        const popup = new MapGatePopup(mapList);
        this.addChild(popup);
        popup.tweenIn();
        HudEmitter.instance.once(HudActions.CLOSE_POPUP, () => {
            popup.tweenOut();
        });
    }

    public addCornerButton(icon: string, trigger: () => void) {
        const button = new CornerButton(icon);
        button.on('trigger', trigger);
        button.on(EmbeddedSprite.events.OnComplete, () => {
            const id = this.cornerButtons.length;
            button.x = button.buttonWidth * 0.5;
            if (Core.orientation === GameOrientation.PORTRAIT) {
                button.x = button.buttonWidth * 0.5;
                button.y =
                    getGameSize().gameHeight -
                    button.buttonHeight * 1.3 -
                    (id * button.buttonHeight) / 1.2;
            } else {
                button.x = getGameSize().gameWidth - button.buttonWidth * 0.5;
                button.y =
                    getGameSize().gameHeight -
                    button.buttonHeight * 1.8 -
                    (id * button.buttonHeight) / 1.2;
            }

            this.addChild(button);
            button.appear();
            this.cornerButtons.push(button);
        });

        return button;
    }

    public removeAllCornerButtons() {
        const cornerButtonsLength = this.cornerButtons.length;
        for (let i = 0; i < cornerButtonsLength; i++) {
            this.removeCornerButtonAt(0, true);
        }
    }

    public removeCornerButton(button: CornerButton) {
        const id = this.cornerButtons.indexOf(button);
        if (id !== -1) {
            this.removeCornerButtonAt(id);
        }
    }

    public removeCornerButtonAt(id: number, multiple?: boolean) {
        const removed = this.cornerButtons[id];
        if (!multiple) {
            let lastY = removed.y;
            for (let i = id + 1; i < this.cornerButtons.length; i++) {
                const current = this.cornerButtons[i];
                TweenLite.to(current, 0.5, { y: lastY });
                lastY = current.y;
            }
        }
        this.cornerButtons.splice(id, 1);
        removed.cleanUp();
        TweenLite.to(removed.scale, 0.5, {
            x: 0,
            y: 0,
            onComplete: () => {
                this.removeChild(removed);
                removed.destroy();
            },
        });
    }

    public addPrizeWheelButton(state: boolean, trigger: () => void) {
        const button = new PrizeWheelButton(state);
        const btnScale = Core.orientation === GameOrientation.PORTRAIT ? 1 : 1.25;
        button.scale.set(btnScale);
        button.originalScale = new PIXI.Point(btnScale, btnScale);
        if (Core.orientation === GameOrientation.PORTRAIT) {
            button.x = gameConfig.game_width * 0.85 + getGameSize().xOffset * 2;
            button.y = gameConfig.game_height * 0.2;
        } else {
            button.x = getGameSize().gameWidth - button.width * 2;
            button.y = gameConfig.game_height * 0.25;
        }

        button.appear();
        button.on('trigger', trigger);
        this.addChild(button);
        this.prizeWheelBtn = button;
        return button;
    }

    public removePrizeWheelButton() {
        if (this.prizeWheelBtn) {
            this.removeChild(this.prizeWheelBtn);
            this.prizeWheelBtn.removeAllListeners();
            this.prizeWheelBtn.destroy();
            this.prizeWheelBtn = null;
        }
    }

    public createPrizeWheelPopup(ts: number) {
        if (this.prizeWheelPopup) {
            return;
        }

        const prizeWheel = new PrizeWheelPopup(ts);
        this.prizeWheelPopup = prizeWheel;
        this.addChild(prizeWheel);
        prizeWheel.tweenIn();
    }

    public async removePrizeWheelPopup() {
        await this.prizeWheelPopup.tweenOut();

        this.prizeWheelPopup = null;
    }

    public createShortcutPopup() {
        const title = Core.local.getText('havingfun');
        const message = `${Core.local.getText('addShorcutMessage')} 
        ${Core.local.getText('reward')}: 500 ${Core.local.getText('coins')} `;
        const confirm = Core.local.getText('add');
        const dismiss = Core.local.getText('notnow');

        const addShortcutPopup = new RewardPopup(
            'character/character-goal',
            'commonui/opt-in_shortcut',
            title,
            message,
            confirm,
            dismiss,
            Popup.SHORTCUT
        );
        this.rewardPopup = addShortcutPopup;
        HudEmitter.instance.once(HudActions.CLOSE_POPUP, (type: Popup) => {
            if (type === Popup.SHORTCUT) {
                this.rewardPopup = null;
            }
        });
        this.addChild(addShortcutPopup);
    }

    public createPurchaseStatusPopup(status: PurchaseStatus) {
        this.purchaseStatusPopup = new PurchaseStatusPopup(status);
        this.addChild(this.purchaseStatusPopup);
        this.purchaseStatusPopup.tweenIn();
    }

    public removePurchaseStatusPopup() {
        this.purchaseStatusPopup.tweenOut();
        this.purchaseStatusPopup = null;
    }

    public createBotPopup() {
        const title = Core.local.getText('freestuff');
        const message = Core.local.getText('subscribetext');
        const confirm = Core.local.getText('turnon');
        const dismiss = Core.local.getText('notnow');

        const popup = new RewardPopup(
            'character/character-win',
            'commonui/opt-in_gift',
            title,
            message,
            confirm,
            dismiss,
            Popup.BOT
        );
        this.rewardPopup = popup;
        HudEmitter.instance.once(HudActions.CLOSE_POPUP, (type: Popup) => {
            if (type === Popup.BOT) {
                this.rewardPopup = null;
            }
        });
        this.addChild(popup);
    }

    public async showCurrAds(
        totalStars: number,
        gainedStars: number,
        totalCoins: number,
        gainedCoins: number,
        totalHearts: number,
        gainedHearts: number,
        totalTokens: number,
        gainedTokens: number,
        gainedTokensCollection: string
    ) {
        if (gainedStars > 0) {
            this.mapUi.stars.showCurrencyValue(totalStars - gainedStars);
            this.rewardAnims.push(new AddCurrencyAnimation(gainedStars, totalStars, this, 'star'));
        }
        if (gainedCoins > 0) {
            this.rewardAnims.push(new AddCurrencyAnimation(gainedCoins, totalCoins, this, 'coin'));
        }
        if (gainedHearts > 0) {
            this.mapUi.hearts.showCurrencyValue(totalHearts - gainedHearts);
            this.rewardAnims.push(
                new AddCurrencyAnimation(gainedHearts, totalHearts, this, 'heart')
            );
        }
        if (gainedTokens > 0) {
            this.rewardAnims.push(
                new AddCurrencyAnimation(
                    gainedTokens,
                    totalTokens,
                    this,
                    'token-' + gainedTokensCollection
                )
            );
        }

        const animation = new Animation({});
        this.rewardAnims.forEach(x => {
            animation.add(() => x.showCurrencyAdded());
            animation.addDelay(x.animationDuration);
        });

        animation.add(() => {
            this.rewardAnims = [];
        });

        await animation.play();
    }

    public async addCoinsAnim(gainedCoins: number, curCoins: number) {
        if (gainedCoins === 0) {
            return;
        }
        const coinAnimation = new AddCoinsAnimationInGame(gainedCoins, curCoins, this.bottomUi);
        coinAnimation.showCurrencyAdded().then(() => {
            coinAnimation.cleanUp();
        });
    }

    public setPaused(paused: boolean) {
        if (this.topUi) {
            this.topUi.setPaused(paused);
        }
    }

    public blurBackground() {
        if (!this.screenBlur) {
            const sBlur = new ScreenBlur();
            sBlur.interactive = true;
            sBlur.alpha = 0;
            this.screenBlur = sBlur;
        } else {
            this.blurs.push(this.getChildIndex(this.screenBlur));
        }
        this.addChild(this.screenBlur);
        TweenLite.to(this.screenBlur, 0.5, { alpha: 1 });
    }

    public removeBlur() {
        if (!this.screenBlur) {
            return;
        }
        if (this.blurs.length > 0) {
            this.addChildAt(this.screenBlur, this.blurs.pop());
            return;
        }
        const screenBlur = this.screenBlur;
        this.screenBlur = null;
        TweenLite.to(screenBlur, 0.2, {
            alpha: 0,
            onComplete: () => {
                this.removeChild(screenBlur);
                screenBlur.destroy();
            },
        });
    }

    public showHelperParachute(friend: IFBFriend, boosterId: BoosterId) {
        if (!this.bottomUi) {
            return null;
        }
        const buttonId = BOOSTER_LIST.includes(boosterId) ? boosterId : BOOSTER_LIST[0];
        const button = this.bottomUi.getButton(buttonId);
        const btnPosition =
            Core.orientation === GameOrientation.PORTRAIT
                ? button.position
                : new PIXI.Point(
                      button.x - this.topUi.bg.width * 0.3,
                      button.y + button.height * 0.5
                  );
        const targetPosition = this.toLocal(btnPosition, button.parent);
        const boosterParachute = new BoosterParachute(friend, boosterId, targetPosition);
        this.addChild(boosterParachute);
        return boosterParachute;
    }

    public addLockList(list: string[]) {
        this.lockList = list;
        if (this.bottomUi) {
            list.forEach(l => this.bottomUi.boosters.lockBooster(l, true));
        }
    }

    public showBotRewardPopup(gifts: Array<[string, number, string?]>) {
        this.blurBackground();

        const rewardGifts = gifts.map(a => {
            const obj: IRewardItem = { id: a[0], val: a[1] };
            return obj;
        });
        const collectionInProgress = getCollectionInProgress();
        const collectionProgress = getCollectionProgress(collectionInProgress);
        const botRewardPopup = new BotRewardPopup(
            Popup.BOTREWARD,
            rewardGifts,
            collectionInProgress,
            collectionProgress
        );
        this.addChild(botRewardPopup);
        this.botRewardPopup = botRewardPopup;
    }

    public removeBotRewardPopup() {
        this.botRewardPopup
            .tweenOut()
            .then()
            .catch()
            .finally(() => {
                this.botRewardPopup = null;
            });
        this.removeBlur();
    }

    private createPauseGroup() {
        const portrait = Core.orientation === GameOrientation.PORTRAIT;
        const btnScale = portrait ? 1 : 1.5;
        const icon = 'commonui/button-icon-settings';

        const pause = new IconButton({ icon, animateIcon: true });

        const direction = portrait ? new PIXI.Point(0, -1) : new PIXI.Point(1, 0);
        const group = new CollapsibleGroup(pause, direction);
        pause.on(UIButton.events.Trigger, () =>
            HudEmitter.instance.emit(HudActions.SET_PAUSE_VISIBLE, !group.isCollapsed)
        );

        const musicButton = new IconButton({ icon: 'commonui/button-icon-music', scale: 0.8 });
        group.addItem(musicButton);
        musicButton.on(UIButton.events.Trigger, () =>
            HudEmitter.instance.emit(HudActions.TOGGLE_MUSIC)
        );

        const soundButton = new IconButton({ icon: 'commonui/button-icon-sound', scale: 0.8 });
        group.addItem(soundButton);
        soundButton.on(UIButton.events.Trigger, () =>
            HudEmitter.instance.emit(HudActions.TOGGLE_SOUND)
        );

        const infoButton = new IconButton({
            icon: 'commonui/button-icon-info',
            color: ButtonColors.ORANGE,
            scale: 0.8,
        });
        infoButton.on(UIButton.events.Trigger, () =>
            HudEmitter.instance.emit(HudActions.ADD_POPUP, Popup.INFO)
        );

        group.addItem(infoButton);

        const quitButton = new IconButton({
            icon: 'commonui/button-icon-quit',
            color: ButtonColors.RED,
            scale: 0.8,
        });
        group.addItem(quitButton);
        quitButton.on(UIButton.events.Trigger, () =>
            HudEmitter.instance.emit(HudActions.ADD_POPUP, Popup.MODAL)
        );

        group.scale.set(btnScale);
        this.pauseGroup = { group, musicButton, soundButton, infoButton, quitButton };
        if (Core.orientation === GameOrientation.PORTRAIT) {
            group.x = getGameSize().gameWidth - group.width * 0.6;
            group.y = getGameSize().gameHeight - group.height * 0.6;
        } else {
            group.x = +group.width * 0.6;
            group.y = getGameSize().gameHeight - group.height * 0.6;
        }

        pause.on('trigger', () => {
            // HudEmitter.instance.emit(HudActions.SET_PAUSED, !group.isCollapsed);
        });
        pause.interactive = true;
        this.addChild(group);
    }
}
